import { httpsCallable } from 'firebase/functions';
import { auth, functionsClient } from '../firebaseConfig';

const fallbackEndpoint = 'https://us-central1-micgro-manager.cloudfunctions.net/joinFarmByInviteCodeHttp';

export async function joinFarmByInviteCodeClient(inviteCode) {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    const err = new Error('You must be signed in.');
    err.code = 'functions/unauthenticated';
    throw err;
  }

  await currentUser.getIdToken(true);
  const idToken = await currentUser.getIdToken();

  try {
    const response = await fetch(fallbackEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({ inviteCode }),
    });
    const data = await response.json().catch(() => ({}));
    if (response.ok) {
      return data;
    }

    const err = new Error(String(data?.message || 'Failed to join farm.'));
    err.code = data?.code ? `functions/${data.code}` : 'functions/unknown';
    throw err;
  } catch (error) {
    if (String(error?.code || '').startsWith('functions/')) {
      throw error;
    }
    const callable = httpsCallable(functionsClient, 'joinFarmByInviteCode');
    const result = await callable({ inviteCode });
    return result?.data || {};
  }
}
